export default {
    gridSize: localStorage.getItem('grid-size'),
    menuMiniState: false,
    menuMobileState: false,
}